import { rgba } from 'polished'

import logError from 'utils/errorLogger'

import { theme } from 'styles/theme'

export const getStatus = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        color: rgba(theme.palette.neutral[800], 0.3),
        fontColor: theme.palette.neutral[400],
        label: 'Pendente'
      }
    case 'overdue':
      return {
        color: '#FFF8ED',
        fontColor: theme.palette.neutral[400],
        label: 'Vencida'
      }
    case 'paid':
      return {
        color: theme.palette.primary[700],
        fontColor: theme.palette.neutral[400],
        label: 'Paga'
      }
    case 'cancelled':
      return {
        color: theme.palette.error[500],
        fontColor: theme.palette.neutral[400],
        label: 'Cancelada'
      }
    // Status da recorrência de contas a pagar (o modal também mostra a recorrência)
    case 'active':
      return {
        color: theme.palette.primary[700],
        fontColor: theme.palette.neutral[400],
        label: 'Ativa'
      }
    case 'finished':
      return {
        color: rgba(theme.palette.neutral[800], 0.3),
        fontColor: theme.palette.neutral[400],
        label: 'Finalizada'
      }
    case 'deleted':
      return {
        color: theme.palette.error[500],
        fontColor: theme.palette.neutral[400],
        label: 'Excluída'
      }
    default:
      // Sem status o dado ainda está carregando: não é status desconhecido.
      if (status) {
        logError(
          `Erro ao mapear status do modal de detalhes da despesa: ${status}`
        )
      }
      return {
        color: rgba(theme.palette.neutral[700], 0.3),
        fontColor: theme.palette.neutral[400],
        label: 'Status desconhecido'
      }
  }
}

export const getHoverText = (status: string) => {
  switch (status) {
    case 'pending':
      return {
        text: 'Rever texto hover'
      }
    case 'overdue':
      return {
        text: 'Rever texto hover'
      }
    case 'paid':
      return {
        text: 'Rever texto hover'
      }
    case 'deleted':
      return {
        text: 'Rever texto hover'
      }

    default:
      logError(`Erro ao mapear o texto da tooltip de despesas: ${status}`)

      return {
        text: 'Status desconhecido'
      }
  }
}
